import React, { useState,useLayoutEffect } from 'react';
import { useNavigate } from "react-router-dom";
import { IconX } from '@tabler/icons-react';
import { notifications } from '@mantine/notifications';
import { Text, Input, Button } from '@mantine/core';
import TestsApi from "../../api/TestsApi";
import { CreateTestSmartCodeModal } from "../../components/CreateTest/CreateTestSmartCodeModal";
import { VisiLoader } from "../../components/GeneralComponent/GeneralComponent";

export function AddTest({
  selectedFunnelRotationPage,
  SelectedMemberWebsite,
  SelectedThumbnails,
  SelectedThumbnail,
  ClassicAbSplitTest,
  }:any) {

  const navigate = useNavigate();
  const [testName, setTestName] = useState('');
  const [isVisiSmartCodeModalOpen, setIsVisiSmartCodeModalOpen] = useState(false);
  const [isVisismartCodeCheck, setIsVisismartCodeCheck] = useState(false);
  // Shows loader seamlessly between VisiSmartCode check and save_classic_ab_rotation_page API without flicker.
  const [isLoaderVisible, setIsLoaderVisible] = useState(false);

    const handleSaveClassicRotationPage = () => {
      setIsLoaderVisible(true);

      TestsApi.saveclassicabrotationpage({
        system_website_id: SelectedMemberWebsite,
        rotation_page: SelectedThumbnails,
        control_page_id: SelectedThumbnail,
        funnel_id: selectedFunnelRotationPage,
        test_name: testName,
      })
      .then((response) => {
        if (response.ok) {
          return response.json();
        } else {
          if (response.status === 401 || response.status === 400) {
            navigate('/logout');
          }
        }
      })
      .then((data) => {
        if (data.status === 1) {
          // Keep loader visible through the navigation to /reviewing-test.
          navigate("/reviewing-test", { state: { pageId: SelectedThumbnail, taguchiTestId:ClassicAbSplitTest, funnelId:selectedFunnelRotationPage } });
        } else {
          if(data.data.ip_address){
            navigate("/multiple-user-login", { state: { ip_address: data.data.ip_address, type: 'create-test', id: SelectedThumbnail } });
          }else{
            setIsLoaderVisible(false);
            notifications.show({
              color: 'red',
              icon: <IconX size="1.1rem" />,
              title: 'Error',
              message: data.message,
            });
          }
        }
      })
      .catch((error) => {
        setIsLoaderVisible(false);
        console.error('API Error:', error);
      });
    };

  const handleCheckVisismartCode = () => {
    setIsVisiSmartCodeModalOpen(true);
  };

  // useLayoutEffect ensures the save-phase loader appears before the modal loader unmounts to prevent flicker.
  useLayoutEffect(() => {
    if(isVisismartCodeCheck){
      handleSaveClassicRotationPage();
      setIsVisismartCodeCheck(false);
    }
  }, [isVisismartCodeCheck]);

  return (
    <>
      <VisiLoader VisiLoaderVisible={isLoaderVisible} />
      {/*START VISISMART CODE MODEL*/}
      {isVisiSmartCodeModalOpen && (
        <CreateTestSmartCodeModal
          selectedMemberWebsite={SelectedMemberWebsite}
          pageId={SelectedThumbnail}
          selectedFunnelName={selectedFunnelRotationPage}
          taguchi_type_id={ClassicAbSplitTest}
          activeTestId='0'
          isVisiSmartCodeModalOpen={isVisiSmartCodeModalOpen}
          onVisiSmartCodeClose={setIsVisiSmartCodeModalOpen}
          testType="classic_test"
          setCheckValidate={setIsVisismartCodeCheck}
        />
      )}
      {/*END VISISMART CODE MODEL*/}
      <form>
        <div style={{ display: 'flex',marginTop:15}}>
          <Text mt={5} mr={5}>Test Name:</Text><div style={{color:"red",marginTop:5}}>*</div>
          <Input w={200} ml={10} value={testName} onChange={(e) => setTestName(e.target.value)} />
          <Button ml={10} style={{color:"white",textDecoration: "none"}} onClick={handleCheckVisismartCode}>Continue</Button>
        </div>
      </form>
    </>
  );
}